import { render } from "./EcomTabs.vue?vue&type=template&id=53dac620"
import script from "./EcomTabs.vue?vue&type=script&lang=js"
export * from "./EcomTabs.vue?vue&type=script&lang=js"

import "./EcomTabs.vue?vue&type=style&index=0&id=53dac620&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/globals/UI/Tab/EcomTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53dac620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53dac620', __exports__)) {
    api.reload('53dac620', __exports__)
  }
  
  module.hot.accept("./EcomTabs.vue?vue&type=template&id=53dac620", () => {
    api.rerender('53dac620', render)
  })

}


export default __exports__